module.exports = __webpack_public_path__ + "dist/fonts/roboto/Roboto-Regular-webfont.svg";


//////////////////
// WEBPACK FOOTER
// ./dist/fonts/roboto/Roboto-Regular-webfont.svg
// module id = 1612
// module chunks = 0